import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class JobGradePayrollProvider {

    private _service: string = 'payroll';
    private _model: string = 'JobGradeServices';

    constructor(
        private nestApiProvider: NestApiProvider,
    ) {
    }

    public getJobGrade(): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'getJobGrade';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _func, _params, _body)
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/job-grade-payroll/job-grade-payroll.ts